import axios from 'axios';
import { v1 as uuid } from 'uuid';

import * as resizin from 'config/resizin';
import config from 'config/index';

import { status } from './constants';

export const uploadImage = (id, file) => {
    const uploadUrl = `${config.cloudFunctions.base}${config.api.upload}`;

    const data = new FormData();

    data.append(id, file);

    return axios.post(uploadUrl, data);
};

export const buildSource = (id, options) => resizin.build(id, options);

export const createId = () => `${config.app.slug}/${uuid().replace(/-/g, '')}`;

export const fileToImage = ({ uid }) => ({ id: uid });

export const mapFilesToImages = (files = []) => files.map(fileToImage);

export const imageToFile = ({ id }) => ({
    uid: id,
    status: status.DONE,
    url: buildSource(id),
    thumbUrl: buildSource(id, { width: 100, height: 100 }),
});

export const mapImagesToFiles = (images = []) => images.map(imageToFile);
